@if (isLoading()) {
<app-spinner data-test-id="account-spinner"></app-spinner>
} @else {
<app-card
  [partialFullHeight]="true"
  size="large"
  [spacingBottom]="Spacing.NONE"
>
  <app-view [direction]="ViewDirection.COLUMN" [spacingBottom]="40">
    <app-title-section
      [size]="2"
      [spacingBottom]="24"
      [title]="'account.subscriptionDetails' | translate"
      [body]="'account.subscriptionDescription' | translate"
      testIdPrefix="account-subscription"
    ></app-title-section>
    <app-key-value-collection
      [collection]="accountData"
      data-test-id="account-key-value-collection"
    ></app-key-value-collection>
  </app-view>
  <app-view [direction]="ViewDirection.COLUMN" [spacingBottom]="40">
    <app-title-section
      [size]="2"
      [title]="'account.invoice' | translate"
      [body]="'account.invoiceDescription' | translate"
      testIdPrefix="account-invoice-section"
    ></app-title-section>
  </app-view>
</app-card>
}
